import { apiKeyClient } from "@better-auth/api-key/client";
import { stripeClient } from "@better-auth/stripe/client";
import { adminClient, magicLinkClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { clearYearDataCache } from "./yearCache";

export const authClient = createAuthClient({
	// Same origin (Bun serves SPA + auth), so no baseURL needed in prod.
	basePath: "/api/auth",
	plugins: [magicLinkClient(), stripeClient({ subscription: true }), apiKeyClient(), adminClient()],
});

export const { useSession, signIn, signUp } = authClient;

/**
 * Signs out and forgets the years cached in this browser. The server clears
 * the guest place pass on the same request.
 */
export const signOut: typeof authClient.signOut = (...args) => {
	clearYearDataCache();
	return authClient.signOut(...args);
};
